import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  OnInit,
} from '@angular/core';

@Component({
  selector: 'nym-card-activity-listing-no-results',
  templateUrl: './card-activity-listing-no-results.component.html',
  styleUrls: ['./card-activity-listing-no-results.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardActivityListingNoResultsComponent implements OnInit {

  @HostBinding('class.nym-card-activity-listing-no-results')
  protected get classes(): boolean { return true; }

  constructor() { }

  public ngOnInit(): void { }

}
